var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userlist"},[_c('b-row',[_c('b-col',[_c(_vm.currentView,{ref:"myCom",tag:"component",on:{"rowadded":_vm.rowadded,"editexit":_vm.editexit,"refreshlist":_vm.refreshlist}})],1)],1),_c('spacer-card'),_c('b-row',[_c('b-col',[_c('users-table',{ref:"usersTable",on:{"rowedit":_vm.rowedit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }